import { Box } from '@mui/material'
import { tss } from 'tss-react/mui'
import { LoadingSpinner } from '~/components/ui/atoms/loading-spinner/LoadingSpinner'
import { getLoadingSpinnerDisplay } from '../loading-button/variants/primitives'
import { MenuButton, MenuButtonProps } from '../menu-button/MenuButton'
import { MenuButtonSize, MenuButtonVariant } from '../menu-button/types'
import { getLoadingContainerPrimitives } from './variants/primitives'

export interface LoadingMenuButtonProps extends MenuButtonProps {
  loading: boolean
}

const useStyles = tss
  .withParams<{ variant: MenuButtonVariant; size: MenuButtonSize; loading: boolean }>()
  .create(({ variant, loading }) => ({
    container: {
      position: 'relative',
      ...getLoadingContainerPrimitives(variant, loading),
    },
  }))

/**
 * Renders a text button with optional start and end icons with a loading state
 */
export function LoadingMenuButton({ variant, size, loading, ...rest }: LoadingMenuButtonProps) {
  const { css, classes } = useStyles({ variant, size, loading })
  return (
    <Box className={classes.container}>
      <LoadingSpinner
        buttonSize={size}
        buttonVariant={variant}
        classes={{ root: css(getLoadingSpinnerDisplay(loading)) }}
        thickness={7}
        type="button"
      />
      <MenuButton
        size={size}
        variant={variant}
        {...rest}
        classes={{ buttons: css(loading ? { visibility: 'hidden' } : {}) }}
      />
    </Box>
  )
}
